import { select, type SelectEffect, type Tail } from 'redux-saga/effects';

export function* selectTyped<Fn extends Exclude<Parameters<typeof select>[0], void>>(
    this: unknown,
    selectorFn: Fn,
    ...args: Tail<Parameters<Fn>>
): Generator<SelectEffect, ReturnType<Fn>, ReturnType<Fn>> {
    return yield select.call(this, selectorFn, ...args);
}
